import Big from "big.js";
import dayjs from "dayjs";
import {
  CaltivationCategoryOptions,
  ProductionHistoryOptions,
} from "../../../constants";
import { UserRole } from '../../../types/UserRole';
import { UserPermission } from '../../../types/UserPermission';
import type { BiddingInfoResult } from '../../../types';

/**
 * DBの文字列を受け取り、日本時間のミリ秒付き文字列に変換する
 */
export const formatJSTWithMillis = (dateStr: string | undefined | null): string => {
  if (!dateStr) return "";
  return dayjs(dateStr).format("YYYY/MM/DD HH:mm:ss.SSS");
};

/**
 * 容量と数量から総重量を計算
 */
export const calculateTotalWeight = (
  capacity1?: number | string | null,
  quantity1?: number | string | null,
  capacity2?: number | string | null,
  quantity2?: number | string | null
): number => {
  try {
    const c1 = new Big(capacity1 || 0);
    const q1 = new Big(quantity1 || 0);
    const c2 = new Big(capacity2 || 0);
    const q2 = new Big(quantity2 || 0);

    return c1.times(q1).plus(c2.times(q2)).toNumber();
  } catch (e) {
    return 0;
  }
};

/**
 * 栽培区分のコードからラベルを取得
 */
export const getCaltivationLabel = (categoryValue?: number | string | null): string => {
  const targetOption = CaltivationCategoryOptions.find(opt => opt.value === categoryValue);
  return targetOption ? targetOption.label : "";
};

/**
 * 生産履歴のコードからラベルを取得
 */
export const getProductionLabel = (historyValue?: number | string | null): string => {
  const targetOption = ProductionHistoryOptions.find(opt => opt.value === historyValue);
  return targetOption ? targetOption.label : "";
};

/**
 * 落札結果の表示文字列を取得
 */
export const getDisplayBidResultText = (
  item: BiddingInfoResult,
  role?: UserRole,
  permission?: number
): string => {
  if (role === UserRole.Buyer) {
    if (item.resultMsg) {
      if (item.resultMsg === "- (抽)") {
        return "他社落札(抽)";
      }
      return item.resultMsg;
    }
    if (Number(item.myBidPrice) > 0 && Number(item.highestBidPrice) > 0) {
      return "他社落札";
    }
    return "";
  }

  if (role === UserRole.JA || role === UserRole.Seller || role === UserRole.Farmer) {
    if (item.resultMsg) {
        if (item.resultMsg === "落札(抽)") {
          return String(item.highestBidPrice ?? '') + "(抽)";
        }
        else if (item.resultMsg === "不成立" || item.resultMsg === null) {
            return "";
          }
        return String(item.highestBidPrice ?? '');
      }
      return String(item.highestBidPrice ?? '');
  }

  if (role === UserRole.Admin) {
    if (permission === UserPermission.Admin) {
      const hasWinner = item.biddingInfoDatas?.some(bid => bid.isWinningBid);
      return hasWinner ? (item.resultMsg || "") : "";
    } else {
      return item.resultMsg || "";
    }
  }

  return "";
};